import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { DevicesSvg } from './svg/devices';

export const DevicesIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DevicesSvg} {...props} />
);
